import _defineProperty from "/app/vetiver/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { makeStyles } from '@material-ui/core/styles';
export var useStyles = makeStyles(function (theme) {
  var _menu, _ref;

  return _ref = {
    divider: {
      margin: '16px 24px !important',
      borderColor: '#A3A3A3 !important',
      opacity: 0.3
    },
    linkButton: {
      display: 'flex',
      color: '#212121',
      fontSize: '16px',
      cursor: 'pointer',
      padding: '8px 24px',
      textDecoration: 'none',
      fontFamily: 'Poppins-SemiBold',
      '&:hover': {
        color: '#212121',
        background: '#F4F6F8'
      }
    },
    listItem: {
      fontSize: '16px',
      cursor: 'pointer',
      padding: '8px 24px !important',
      fontFamily: 'Poppins-Regular',
      '&:hover': {
        color: '#4519EF',
        background: '#F4F6F8 !important',
        cursor: 'pointer'
      }
    },
    cursorDefault: {
      cursor: 'default'
    },
    closeIcon: {
      width: '18px',
      height: '18px',
      color: '#434242 !important',
      '&:hover': {
        backgroundColor: 'white !important'
      }
    },
    languages: {
      marginBottom: '25px',
      marginLeft: '2%',
      marginRight: '2%'
    },
    subItem: {
      backgroundColor: 'rgba(89, 89, 89, 0.5)'
    },
    profile: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    active: {
      borderRadius: '3px',
      backgroundColor: 'rgba(89, 89, 89, 0.5)',
      color: '#ffffff'
    },
    content: {
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0
    },
    list: {
      padding: '65px 0',
      margin: '0 15px'
    },
    accordionSummary: {
      margin: '0 !important',
      color: '#212121 !important',
      padding: '8px 24px !important',
      background: '#fff !important',
      minHeight: 'max-content !important',
      '&:hover': {
        background: '#F4F6F8 !important'
      },
      '& $svg': {
        color: '#212121'
      },
      '& $selected': {
        background: '#F4F6F8 !important'
      }
    },
    accordion: {
      cursor: 'pointer',
      fontSize: '16px',
      borderBottom: 'none',
      position: 'relative',
      fontFamily: 'Poppins-Medium',
      color: '#212121 !important',
      '&:hover': {
        borderRadius: '3px'
      },
      '&:before': {
        display: 'none'
      },
      '.Mui-expanded': {
        margin: '0 !important'
      }
    },
    accordionDetail: {
      gap: '8px',
      display: 'grid',
      marginTop: '8px'
    },
    removePadding: {
      padding: '0px !important'
    },
    expanded: {
      '&$expanded': {
        margin: '0 !important'
      }
    },
    item_link: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      color: '#ffffff',
      fontFamily: theme.typography.fontFamily,
      fontWeight: 600,
      fontSize: '14px',
      letterSpacing: 0,
      lineHeight: '48px',
      '&:hover': {
        color: '#fff'
      }
    },
    language: {
      margin: 'unset',
      cursor: 'pointer'
    },
    title: {
      marginLeft: '16px',
      marginBottom: '6px',
      color: '#212121',
      fontFamily: 'Poppins-Bold',
      fontSize: '18px',
      letterSpacing: 0,
      lineHeight: '22px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: '200px',
      textTransform: 'capitalize'
    },
    subtitle: {
      marginLeft: '16px',
      color: '#212121',
      fontFamily: 'Poppins-SemiBold',
      fontSize: '16px',
      letterSpacing: 0,
      lineHeight: '24px',
      display: 'inline-flex',
      gap: '8px',
      textTransform: 'uppercase'
    },
    badge: {
      marginLeft: '15px',
      minWidth: '54.15px',
      height: '54.15px',
      width: '54.15px'
    },
    welcomeBack: {
      color: '#212121',
      fontSize: '20px',
      lineHeight: '30px',
      fontFamily: 'Poppins-SemiBold'
    },
    loginLabelBtn: {
      height: '42px',
      width: 'auto',
      textTransform: 'none',
      color: '#fff !important',
      fontSize: '16px !important',
      marginTop: '5px !important',
      lineHeight: '26px !important',
      padding: '8px 40px !important',
      borderRadius: '50px !important',
      background: '#4519EF !important',
      fontFamily: 'Poppins-SemiBold !important',
      '&:hover': {
        color: '#fff',
        background: '#3E15D7',
        borderRadius: '50px !important',
        boxShadow: '0px 0px 2px 0px rgba(145, 158, 171, 0.24), 0px 12px 24px 0px rgba(145, 158, 171, 0.24)'
      }
    },
    signUpBtn: {
      color: '#212121',
      cursor: 'pointer',
      fontSize: '14px',
      lineHeight: '24px',
      textDecoration: 'underline',
      fontFamily: 'Poppins-Regular'
    },
    menu: (_menu = {
      transition: 'opacity 0.5s',
      position: 'fixed',
      width: '100%',
      height: '100%',
      overflow: 'auto',
      left: 0,
      top: 0,
      zIndex: 1001,
      color: '#fff',
      background: '#333',
      opacity: 0
    }, _defineProperty(_menu, theme.breakpoints.down('lg'), {
      width: '45%',
      left: '55%',
      display: 'block'
    }), _defineProperty(_menu, theme.breakpoints.down('md'), {
      width: '60%',
      left: '40%'
    }), _defineProperty(_menu, theme.breakpoints.down('sm'), {
      width: '100%',
      left: 0
    }), _menu),
    open: {
      opacity: '1',
      visibility: 'visible'
    },
    bar: {
      height: '65px',
      width: '100%',
      zIndex: 1002,
      background: 'linear-gradient(180deg, #333 0%, #333 15%, transparent 100%)',
      position: 'fixed'
    },
    social: {
      display: 'flex',
      justifyContent: 'center',
      margin: '16px 0',
      gap: '8px'
    },
    social_link: {
      backgroundColor: '#333',
      borderRadius: '50% !important',
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      width: '32px',
      height: '32px',
      '&:hover': {
        opacity: 0.8
      }
    },
    social_svg: {
      color: '#fff',
      fontSize: '18px'
    },
    show: {
      display: 'block !important'
    }
  }, _defineProperty(_ref, theme.breakpoints.down('lg'), {
    show: {
      display: 'none !important'
    }
  }), _defineProperty(_ref, "backdrop", _defineProperty({
    zIndex: 100,
    width: '100vw',
    height: '100vh',
    position: 'fixed',
    top: 0,
    left: 0,
    display: 'none'
  }, theme.breakpoints.down('lg'), {
    display: 'none !important'
  })), _ref;
});